import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import metricsState from './state';
export const metricsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => metricsState);
    },
    initialState: metricsState,
    name: 'metrics',
    reducers: {
        errorReceiveAllMetrics: state => {
            state.allMetrics = undefined;
            state.requestingAllMetrics = false;
        },
        errorReceiveMetrics: state => {
            state.metrics = undefined;
            state.requestingMetrics = false;
        },
        errorReceiveRackMetrics: state => {
            state.rackMetrics = undefined;
            state.requestingRackMetrics = false;
        },
        failedReceiveAllMetrics: state => {
            state.allMetrics = undefined;
            state.requestingAllMetrics = false;
        },
        failedReceiveMetrics: state => {
            state.metrics = undefined;
            state.requestingMetrics = false;
        },
        failedReceiveRackMetrics: state => {
            state.rackMetrics = undefined;
            state.requestingRackMetrics = false;
        },
        receiveAllMetrics: {
            prepare: allMetrics => {
                return {
                    payload: {
                        allMetrics
                    }
                };
            },
            reducer: (state, action) => {
                const { allMetrics } = action.payload;
                state.allMetrics = allMetrics;
                state.requestingAllMetrics = false;
            }
        },
        receiveMetrics: {
            prepare: metrics => {
                return {
                    payload: {
                        metrics
                    }
                };
            },
            reducer: (state, action) => {
                const { metrics } = action.payload;
                state.metrics = metrics;
                state.requestingMetrics = false;
            }
        },
        receiveRackMetrics: {
            prepare: rackMetrics => {
                return {
                    payload: {
                        rackMetrics
                    }
                };
            },
            reducer: (state, action) => {
                const { rackMetrics } = action.payload;
                state.rackMetrics = rackMetrics;
                state.requestingRackMetrics = false;
            }
        },
        requestAllMetrics: state => {
            state.requestingAllMetrics = true;
        },
        requestMetrics: {
            prepare: locationSlug => {
                return {
                    payload: {
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingMetrics = true;
            }
        },
        requestRackMetrics: {
            prepare: (locationSlug, rackId) => {
                return {
                    payload: {
                        locationSlug,
                        rackId
                    }
                };
            },
            reducer: state => {
                state.requestingRackMetrics = true;
            }
        },
        resetMetrics: () => metricsState,
        resetRackMetrics: state => {
            state.rackMetrics = undefined;
            state.requestingRackMetrics = false;
        }
    }
});
export const { errorReceiveAllMetrics, errorReceiveMetrics, errorReceiveRackMetrics, failedReceiveAllMetrics, failedReceiveMetrics, failedReceiveRackMetrics, receiveAllMetrics, receiveMetrics, receiveRackMetrics, requestAllMetrics, requestMetrics, requestRackMetrics, resetMetrics, resetRackMetrics } = metricsSlice.actions;
export default metricsSlice.reducer;
